import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext.tsx';
import { Logo } from '../../components/Logo.tsx';
import { useUnreadCount } from '../../messages.ts';

export function AdminLayout() {
  const { user, logout } = useAuth();
  const isSuper = user?.role === 'SUPER_ADMIN';
  const unread = useUnreadCount(Boolean(user));

  const links = [
    { to: '/admin', label: 'Vue d’ensemble', end: true },
    { to: '/admin/users', label: 'Utilisateurs' },
    { to: '/admin/missions', label: 'Missions' },
    ...(isSuper ? [{ to: '/admin/referrers', label: 'Apporteurs' }, { to: '/admin/conformite', label: 'Conformité extras' }, { to: '/admin/verifications', label: 'Vérifications' }, { to: '/admin/referentiel', label: 'Référentiel' }, { to: '/admin/notation', label: 'Notation' }, { to: '/admin/settings', label: 'Paramètres' }] : []),
    { to: '/admin/moderation', label: 'Modération' },
    { to: '/admin/messagerie', label: unread > 0 ? `Messagerie (${unread})` : 'Messagerie' },
    { to: '/admin/audit', label: 'Journal d’audit' },
    { to: '/admin/appearance', label: 'Apparence du site' },
  ];

  return (
    <div style={{ maxWidth: 1080, margin: '0 auto', padding: '24px 20px 48px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 16 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <Logo size={26} />
          <div style={{ fontSize: 12.5, color: 'var(--text-secondary)' }}>
            Back-office · {user?.firstName} {user?.lastName}
          </div>
        </div>
        <button className="btn btn-danger-outline btn-sm" onClick={() => logout()}>Se déconnecter</button>
      </div>

      <nav style={{ display: 'flex', gap: 6, overflowX: 'auto', paddingBottom: 12, marginBottom: 20, borderBottom: '1px solid var(--border)' }}>
        {links.map((l) => (
          <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`}>
            {l.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
